// extracted by mini-css-extract-plugin
module.exports = {"scanFaceDialog":"_7974","main":"_15558","icon":"_18920","tips":"_17511","button":"_17254","close":"_10021","selfPickCodeDialog":"_16589","qrcode":"_16783","text":"_7797"};